<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  computed: {
    menus () {
      return this.$store.state.menus
    }
  },
  created () {
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        if (this.menus && this.menus.length) {
          this.$store.commit('setPermission', to.fullPath)
        }
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  box-sizing: border-box;
}

body {
  height: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;
}

body .el-table th.gutter{
  display: table-cell !important;
}

html {
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.w-e-text table td, .w-e-text table th {
  height: 30px;
}
</style>
